import React from 'react';
import {StyledLinearLoaderBar1, StyledLinearLoaderBar2, StyledLinearLoaderWrapper} from './styled';


interface LinearLoaderProps {
    size?: number | undefined;
    isLoading: boolean;
    big?: boolean;
}

const LinearLoader: React.FC<LinearLoaderProps> = ({size, isLoading, big = false}) => {
	if (!isLoading) {
		return null;
	}

	return (
		<StyledLinearLoaderWrapper $size={size} $big={big}>
			<StyledLinearLoaderBar1 $big={big} />
			<StyledLinearLoaderBar2 $big={big} />
		</StyledLinearLoaderWrapper>
	);
};

export default LinearLoader;